import { Component, OnInit,Input } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-help-text',
  templateUrl: './help-text.component.html',
  styleUrls: ['./help-text.component.css']
})
export class HelpTextComponent implements OnInit {
  constructor(

  ) { }
  param:any;
  @Input() public contentKey: string=""
   public demoTitle: string=""
  
  ngOnInit() {
  }

  initializeJs(){
    $("#instructions").modal('show');
  }
}
